// removed by extract-text-webpack-plugin
module.exports = {"row":"_13f7uK1KJk0gqjkB2VrQlH","col":"_7ktN7js5iuetRPTlal4eH","pull-right":"_1M7ZxfiCZt2W2PYdIqvvrr","pull-left":"_34yQX66tGLCWmE2dB3lakj","padding8":"_3nYkNsysU8o08ANudjW7qb","padding16":"XnS7IEDOYf1ibtHRB6JGT","userid":"_1W2x5XvX7gVHlzoEew1MqR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAccount/UserAccount.scss
// module id = 2678
// module chunks = 0